import { DateTime } from 'luxon';
import { ElegibilidadeLancamentoNovaHome, ModalidadePeriodo, TipoCurso } from './elegibilidade-aluno-nova-home.types';

const elegibilidadeLancamentoNovaHome: ElegibilidadeLancamentoNovaHome = {
  fases: [
    {
      fase: 1,
      habilitarAPartirDe: '10/02/2026',
      modo: 'SEGMENTADO',
      segmentacoes: [
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.SEMI, ModalidadePeriodo.FLEX],
          periodo: ['2026.1'],
          codigoCurso: ['7022', '7024'],
        },
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.GRADUACAO_TECNOLOGICA],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['4070', '4389', '4334', '3631'],
        },
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.ESPECIALIZACAO],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['3592'],
        },
        {
          marcas: ['wyden'],
          tipoCurso: [TipoCurso.GRADUACAO_TECNOLOGICA],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['4340'],
        },
        {
          marcas: ['wyden'],
          tipoCurso: [TipoCurso.ESPECIALIZACAO],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['3629'],
        },
        {
          marcas: ['ibmec'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.PRESENCIAL],
          periodo: ['2026.1'],
          codigoCurso: ['19'],
        },
      ],
    },
    {
      fase: 2,
      habilitarAPartirDe: '09/03/2026',
      modo: 'SEGMENTADO',
      segmentacoes: [
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['10', '4000', '4001', '4024', '646'],
        },
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.SEMI, ModalidadePeriodo.FLEX],
          periodo: ['2026.1'],
          codigoCurso: ['7106'],
        },
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.PRESENCIAL],
          periodo: ['2026.1'],
          codigoCurso: ['21', '166', '2215'],
        },
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.GRADUACAO_TECNOLOGICA],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['4341'],
        },
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.ESPECIALIZACAO],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['3582', '5313'],
        },
        {
          marcas: ['wyden'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['2', '11', '22', '4001', '3389', '7317'],
        },
        {
          marcas: ['wyden'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.PRESENCIAL],
          periodo: ['2026.1'],
          codigoCurso: ['2215'],
        },
        {
          marcas: ['wyden'],
          tipoCurso: [TipoCurso.GRADUACAO_TECNOLOGICA],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['3631', '7340'],
        },
        {
          marcas: ['wyden'],
          tipoCurso: [TipoCurso.GRADUACAO_TECNOLOGICA],
          modalidade: [ModalidadePeriodo.PRESENCIAL],
          periodo: ['2026.1'],
          codigoCurso: ['4340'],
        },
        {
          marcas: ['wyden'],
          tipoCurso: [TipoCurso.ESPECIALIZACAO],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['972', '3595'],
        },
        {
          marcas: ['ibmec'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.PRESENCIAL],
          periodo: ['2026.1'],
          codigoCurso: ['2', '3', '3389', '4995'],
        },
        {
          marcas: ['idomed'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.PRESENCIAL],
          periodo: ['2026.1'],
          codigoCurso: ['51'],
        },
      ],
    },
    {
      fase: 3,
      habilitarAPartirDe: '16/03/2026',
      modo: 'SEGMENTADO',
      segmentacoes: [
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['2', '3', '11'],
        },
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.FLEX],
          periodo: ['2026.1'],
          codigoCurso: ['7109'],
        },
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.PRESENCIAL],
          periodo: ['2026.1'],
          codigoCurso: ['1', '21'],
        },
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.SEMI, ModalidadePeriodo.FLEX],
          periodo: ['2026.1'],
          codigoCurso: ['7035'],
        },
        {
          marcas: ['estacio'],
          tipoCurso: [TipoCurso.GRADUACAO_TECNOLOGICA],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['4366'],
        },
        {
          marcas: ['wyden'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['556'],
        },
        {
          marcas: ['wyden'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.PRESENCIAL],
          periodo: ['2026.1'],
          codigoCurso: ['1', '21', '556'],
        },
        {
          marcas: ['wyden'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.SEMI, ModalidadePeriodo.FLEX],
          periodo: ['2026.1'],
          codigoCurso: ['7018'],
        },
        {
          marcas: ['wyden'],
          tipoCurso: [TipoCurso.GRADUACAO_TECNOLOGICA],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['4339'],
        },
        {
          marcas: ['ibmec'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.PRESENCIAL],
          periodo: ['2026.1'],
          codigoCurso: ['1'],
        },
        {
          marcas: ['ibmec'],
          tipoCurso: [TipoCurso.GRADUACAO],
          modalidade: [ModalidadePeriodo.EAD],
          periodo: ['2026.1'],
          codigoCurso: ['8521'],
        },
      ],
    },
    {
      fase: 4,
      habilitarAPartirDe: '', // substituir pela data real
      modo: 'TODOS',
    },
  ],
};

export const getElegibilidadeAlunoNovaHome = ({ ambiente }: { ambiente: string }): ElegibilidadeLancamentoNovaHome => {
  if (ambiente === 'dev' || ambiente === 'local') {
    return {
      fases: [
        {
          fase: 1,
          habilitarAPartirDe: DateTime.now().minus({ day: 1 }).toFormat('dd/MM/yyyy'),
          modo: 'TODOS',
        },
      ],
    };
  }

  return elegibilidadeLancamentoNovaHome;
};
